/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useRef, useState, useEffect } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import IconClose from '@material-ui/icons/Close';
import {
    object, func, string, bool,
} from 'prop-types';
import GraphqlWineRestrictions from './GraphqlWineRestrictions';

const styles = (theme) => ({
    mobileModal: {
        padding: '20px',
        '& .top-content': {
            textAlign: 'center',
        },
        '& .verification-container': {
            margin: '0 auto',
            maxWidth: 240,
        },
        '& .input-field': {
            minHeight: 85,
        },
        '& .zip-code-label': {
            margin: 0,
        },
        '& .zip-code-box': {
            paddingTop: 15,
        },
        '& .age-verification::after': {
            left: 15,
            top: 0,
        },
        '& .age-verification.success::after': {
            padding: 5,
        },
        '& .age-verification.success::before': {
            top: -15,
        },
        '& .zip-code-success::after': {
            right: 15,
        },
        '& .zip-code-success': {
            '&::before': {
                top: -30,
                right: 75,
            },
        },
        '& .zip-code-error': {
            '&::after': {
                top: -30,
                right: 30,
            },
        },
        '& p': {
            margin: '10px',
        },
    },
    addonBox: {
        '& .age-verification': {
            position: 'relative',
        },
        '& .age-verification::after': {
            left: 20,
            top: -10,
        },
        '& .zip-code-box': {
            paddingTop: 0,
        },
    },
    icon: {
        color: theme.palette.colorIconHeader,
        height: '40px',
        textAlign: 'right',
    },
    topContent: {
        display: 'flex',
        flexDirection: 'row',
    },
    main: {
        width: '633px',
        height: '230px',
        margin: '0px 0px 18px 0px',
    },
    cardTitleZipCode: {
        fontSize: '16px',
        fontWeight: '700',
        margin: '31px 0px 8px 0px',
    },
    cardTitleBirth: {
        fontSize: '16px',
        fontWeight: '700',
        margin: '15px 0px 8px 0px',
    },
    textField: {
        minHeight: '45px',
        margin: '0px 0px 0px 15px',
        '& .MuiFormHelperText-root': {
            fontSize: '9px',
        },
        '& .MuiInputBase-root': {
            display: 'block',
        },
        '& .MuiInputBase-input': {
            padding: '9px 0',
            textAlign: 'center',
        },
    },
    verificationContainer: {
        display: 'block',
    },
    zipcode: {
        width: '100%',
        paddingTop: '40px',
        '& .MuiInputBase-input': {
            width: '68px',
            height: '29px',
            border: `1px solid ${theme.palette.cms?.wineVerifyDisable || '#b9b8b8'}`,
            backgroundColor: theme.palette.primary?.contrastText,
            '&:disabled': {
                backgroundColor: theme.palette.cms?.wineVerifyDisable || '#b9b8b8',
            },
        },
        '& .zip-code-error': {
            '&::before': {
                top: -20,
            },
        },
    },
    birth: {
        width: '250px',
        justifyContent: 'center',
    },
    submit: {
        color: theme.palette.white,
        backgroundColor: theme.palette.black || '#1f1f1b',
        fontFamily: theme.typography.fontFamily,
        boxSizing: 'border-box',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '700',
        width: '84px',
        height: '32px',
        fontSize: '13px',
        borderRadius: '28px',
        lineHeight: '1.46em',
        margin: '-75px 0px 0px 80px',
        '&:disabled': {
            backgroundColor: theme.palette.cms?.wineVerifyDisable || '#b9b8b8',
            color: theme.palette.grey8,
        },
        '&:hover': {
            backgroundColor: theme.palette.black || '#1f1f1b',
        },
    },
    form: {
        width: '150px',
        margin: '8px 0px 0px 0px',
    },
    enterBirthInput: {
        width: '52px',
        height: '40px',
        border: `1px solid ${theme.palette.grey8}`,
        fontSize: '16px',
        marginTop: '3px',
        backgroundColor: theme.palette.primary?.contrastText,

    },
    enterBirthYearInput: {
        width: '65px',
        height: '40px',
        border: `1px solid ${theme.palette.grey8}`,
        fontSize: '16px',
        marginTop: '3px',
        backgroundColor: theme.palette.primary?.contrastText,
    },
    ageFieldsInput: {
        margin: '2px 2px 0px -12px',
    },
    ageVerificationSummary: {
        marginTop: '-13px',
    },
    zipField: {
        textAlign: 'center',
    },
    additionalCompliance: {
        backgroundColor: theme.palette.cms?.additionalComplianceColor || '#f9f6f6',
        color: theme.palette.black || '#1f1f1b',
        padding: '5px',
        fontSize: '0.8em',
        lineHeight: '1.4em',
        '& p': {
            margin: '10px',
        },
    },
    complianceLink: {
        color: theme.palette.black || '#1f1f1b',
        background: 'transparent',
        border: '0',
        padding: '0',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    dialogMain: {
        position: 'relative',
    },
    wineContainer: {
        padding: '0 10px',
        fontSize: '0.8em',
        minHeight: '120px',
        minWidth: '300px',
        '& h4': {
            fontSize: '1.2em',
        },
        '& h5': {
            fontSize: '1em',
        },
        '& h6': {
            fontSize: '1em',
        },
    },
    wineHeader: {
        display: 'inline-block',
    },
    wineHeaderClose: {
        display: 'inline-block',
        right: '10px',
        top: '3px',
        position: 'absolute',
        backgroundColor: theme.palette.white || '#ffffff',
        cursor: 'pointer',
    },
});

const AgeVerificationForm = ({
    classes,
    oncloseDrawer,
    getBirthMonth,
    validateFields,
    birthMonth,
    monthErrorMessage,
    getBirthDay,
    birthDay,
    dayErrorMessage,
    getBirthYear,
    birthYear,
    yearErrorMessage,
    handleAgeVerification,
    handleZipChange,
    validateZip,
    zipField,
    zipFieldRef,
    displayZipValidCSSCheck,
    isModal,
    wineContainerRef,
    displayAdditionalCompliance,
    isDrawer,
}) => {
    const yearFieldRef = useRef(null);
    const monthFieldRef = useRef(null);
    const dayFieldRef = useRef(null);

    const [triggerRestrictions, showWineShippingDetails] = useState(false);

    useEffect(() => {
        if (wineContainerRef.current && wineContainerRef.current.scrollIntoView) {
            wineContainerRef.current.scrollIntoView({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }
    }, [triggerRestrictions]);

    return (
        (isModal || isDrawer) && !triggerRestrictions ? (
            <>
                <div className={isModal ? classes.mobileModal : classes.addonBox}>
                    <div className={`top-content ${classes.topContent}`}>
                        <h3>Confirm Your Age and Destination For Wine Purchase</h3>
                        {!isModal && (
                            <div
                                className={classes.iconHeader}
                                onClick={() => oncloseDrawer(false)}
                                onKeyDown={() => { }}
                                role="button"
                                tabIndex={-1}
                            >
                                <IconClose className={classes.icon} />
                            </div>
                        )}
                    </div>
                    <p className={classes.ageVerificationSummary}>
                        I am at least 21 years of age and
                        I understand that any person accepting delivery of alcoholic
                        beverages must be at least
                        21 years of age and be home to sign for the delivery
                    </p>
                    <div className={`verification-container ${classes.verificationContainer}`} data-testid="age-verification-model">
                        <div className={classes.birth}>
                            <p className={classes.cardTitleBirth}>
                                Enter Your Date Of Birth
                            </p>
                            <Grid container direction="row" className={classes.ageFieldsInput}>
                                <div className={`input-field ${classes.textField}`}>
                                    <div>Month</div>
                                    <TextField
                                        inputRef={monthFieldRef}
                                        margin="dense"
                                        id="month"
                                        type="tel"
                                        placeholder="mm"
                                        onChange={(e) => {
                                            getBirthMonth(e);
                                            if (e.target.value.length === 2) {
                                                dayFieldRef.current.focus();
                                            }
                                        }}
                                        className={classes.enterBirthInput}
                                        onBlur={validateFields}
                                        onKeyUp={validateFields}
                                        value={birthMonth}
                                        inputProps={{
                                            'data-testid': 'month-field',
                                            maxLength: 2,
                                            pattern: '[0-9]/g',
                                            shrink: true,
                                            min: 1,
                                            max: 12,
                                        }}
                                        error={monthErrorMessage !== ''}
                                        helperText={monthErrorMessage}
                                    />
                                </div>
                                <div className={`input-field ${classes.textField}`}>
                                    <div>Day</div>
                                    <TextField
                                        margin="dense"
                                        id="day"
                                        inputRef={dayFieldRef}
                                        type="tel"
                                        placeholder="dd"
                                        onChange={(e) => {
                                            getBirthDay(e);
                                            if (e.target.value.length === 2) {
                                                yearFieldRef.current.focus();
                                            }
                                        }}
                                        className={classes.enterBirthInput}
                                        onBlur={validateFields}
                                        onKeyUp={validateFields}
                                        value={birthDay}
                                        inputProps={{
                                            'data-testid': 'day-field',
                                            maxLength: 2,
                                            pattern: '[0-9]/g',
                                            shrink: true,
                                            min: 1,
                                            max: 31,
                                        }}
                                        error={dayErrorMessage !== ''}
                                        helperText={dayErrorMessage}
                                    />
                                </div>
                                <div className={`input-field ${classes.textField}`}>
                                    <div>Year</div>
                                    <TextField
                                        inputRef={yearFieldRef}
                                        margin="dense"
                                        id="year"
                                        label=""
                                        type="tel"
                                        placeholder="yyyy"
                                        className={classes.enterBirthYearInput}
                                        onChange={getBirthYear}
                                        onKeyUp={validateFields}
                                        onBlur={validateFields}
                                        value={birthYear}
                                        inputProps={{
                                            maxLength: 4,
                                            'data-testid': 'year-field',
                                            pattern: '[0-9]/g',
                                            shrink: true,
                                        }}
                                        error={yearErrorMessage !== ''}
                                        helperText={yearErrorMessage}
                                    />
                                </div>
                                <div disabled={!handleAgeVerification().flag} className={`age-verification ${handleAgeVerification().class}`} />
                            </Grid>
                        </div>
                        <div className={`zip-code-box ${classes.zipcode}`}>
                            <p className={`zip-code-label ${classes.cardTitleZipCode}`}>
                                Enter Destination ZIP code
                            </p>
                            <span>ZIP code</span>
                            <div className={classes.form}>
                                <Input
                                    className={classes.zipField}
                                    disabled={!handleAgeVerification().flag}
                                    type="tel"
                                    margin="normal"
                                    id="zipcode-text-field"
                                    data-test="pdp-zipcode-text-field"
                                    name="zipcodeTextField"
                                    onChange={handleZipChange}
                                    // defaultValue={userSubmittedZip}
                                    value={zipField}
                                    inputRef={zipFieldRef}
                                    inputProps={{
                                        'data-testid': 'zip-code-field',
                                        maxLength: 5,
                                        className: classes.zipField,
                                    }}
                                />
                            </div>
                            <Button
                                disabled={!handleAgeVerification().flag}
                                className={classes.submit}
                                id="confirm-age-zip"
                                data-testid="confirm-age-zip"
                                onClick={validateZip}
                            >
                                Confirm
                            </Button>
                            <div className={displayZipValidCSSCheck().classes} />
                        </div>
                    </div>
                </div>
                {isModal && displayAdditionalCompliance && (
                    <div className={classes.additionalCompliance} data-testid="age-verification-additional-compliance">
                        <p>
                            <button
                                type="button"
                                className={classes.complianceLink}
                                onClick={() => {
                                    showWineShippingDetails(true);
                                }}
                            >
                                Click Here
                            </button> for further details and restrictions relating to the purchase of wine, and a list of states to which Harry &amp; David wine can be shipped. You must be 21 years of age or older to order, purchase or receive delivery of wine. A person who is 21 years of age or older must be home to sign for the delivery. Offer void where prohibited by law.
                        </p>
                        <p><strong>Promotions, Celebrations Passport<sup>®</sup>, coupons and special offers do not apply to products containing wine.</strong> Harry &amp; David wine is sold and shipped by Harry and David, LLC, Medford, Oregon.</p>
                        <p><strong>WARNING</strong>: Drinking wine and other alcoholic beverages may increase cancer risk, and, during pregnancy, can cause birth defects. For more information go to <a className={classes.complianceLink} href="https://www.P65Warnings.ca.gov/alcohol" target="_blank" rel="noreferrer">www.P65Warnings.ca.gov/alcohol</a>.</p>
                    </div>
                )}
            </>
        ) : (
            <div className={classes.wineContainer} data-testid="wine-shipping-details">
                <h4 className={classes.wineHeader}>WINE SHIPPING DETAILS</h4>
                <div className={classes.wineHeaderClose} role="presentation" onClick={() => { showWineShippingDetails(false); }}>
                    <IconClose className={classes.icon} />
                </div>
                <GraphqlWineRestrictions path="/h/view/wineship" />
            </div>
        )
    );
};

AgeVerificationForm.defaultProps = {
    isModal: false,
    isDrawer: false,
    wineContainerRef: {},
    displayAdditionalCompliance: false,
};

AgeVerificationForm.propTypes = {
    classes: object.isRequired,
    zipField: string.isRequired,
    birthDay: string.isRequired,
    birthMonth: string.isRequired,
    birthYear: string.isRequired,
    dayErrorMessage: string.isRequired,
    monthErrorMessage: string.isRequired,
    yearErrorMessage: string.isRequired,
    zipFieldRef: func.isRequired,
    getBirthDay: func.isRequired,
    getBirthMonth: func.isRequired,
    getBirthYear: func.isRequired,
    handleAgeVerification: func.isRequired,
    validateFields: func.isRequired,
    handleZipChange: func.isRequired,
    displayZipValidCSSCheck: func.isRequired,
    validateZip: func.isRequired,
    oncloseDrawer: func.isRequired,
    displayAdditionalCompliance: bool,
    isModal: bool,
    isDrawer: bool,
    wineContainerRef: object,
};

export default withStyles(styles)(AgeVerificationForm);
